export const company_details = {
  name: 'SIGNET DIGITAL PRIVATE LIMITED',
  address:"Golden Park Commercial Complex, Sai Nagar, Vasai, Palghar - 401202"
};


